import React, { useMemo } from "react";

/**
 * SplitText — animates each word of a headline with an elegant staggered rise+fade.
 * Each word is wrapped in an overflow-hidden "line" so words appear to lift from beneath an invisible margin.
 * Re-triggers when `text` changes (good for EN/FR language toggle) thanks to keyed words.
 */
export default function SplitText({
  text = "",
  className = "",
  stagger = 110,          // ms between words
  initialDelay = 100,     // ms before first word starts
  duration = 1000,        // ms per word
  as: Tag = "span",
  testId,
}) {
  const words = useMemo(() => text.split(/\s+/).filter(Boolean), [text]);

  return (
    <Tag data-testid={testId} className={className} aria-label={text}>
      {words.map((word, i) => (
        <span
          key={`${text}-${i}-${word}`}
          className="qw-split-line"
          aria-hidden="true"
        >
          <span
            className="qw-split-word"
            style={{
              animationDelay: `${initialDelay + i * stagger}ms`,
              animationDuration: `${duration}ms`,
            }}
          >
            {word}
          </span>
          {i < words.length - 1 ? "\u00A0" : ""}
        </span>
      ))}
    </Tag>
  );
}
